"use client"

import { motion } from "framer-motion"

export function About() {
  return (
    <section id="about-section" className="bg-gray-50 py-12 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="order-2 md:order-1 p-6 md:p-8 lg:p-12 flex flex-col justify-center items-center"
        >
          <div className="max-w-xl lg:pl-12">
            <h2 className="text-3xl mb-6 text-[#3f4141]">About Raintree</h2>
            <p className="text-gray-600 mb-6">
              Raintree was created with one simple intention: to slow things down.
            </p>
            <p className="text-gray-600 mb-6">
              After working across many clinics over 2 decades, Renee wanted to build a space where there's time to slow down, to listen and to heal.
            </p>
            <p className="text-gray-600">
              At Raintree, acupuncture is thoughtful and unhurried. Renee provides care that is personal, considered, and grounded in experience of the rich knowledge and wisdom of Chinese Medicine.
            </p>
            <p className="text-gray-600 mt-6">
              Providing detailed treatment plans, you'll always know what to expect in each treatment, how many sessions you may need, and what steps you can take along the healing journey.
            </p>
          </div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="order-1 md:order-2 md:h-full p-6 md:p-8 lg:p-12 flex items-center justify-center"
        >
          <img
            src="https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-Clinic-01.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLUNsaW5pYy0wMS5wbmciLCJpYXQiOjE3NjIyOTg1MTAsImV4cCI6NDg4NDM2MjUxMH0.1nvCGNDy0JWPtQgOK01sXS3NrDSBO0rMKqTYRvT4Mfo"
            alt="Peaceful clinic environment"
            className="aspect-square md:aspect-auto object-cover w-full md:w-auto md:h-full md:max-h-[600px] shadow-lg"
          />
        </motion.div>
      </div>
    </section>
  )
}